import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Assuming we need a close icon
import { FaBell } from 'react-icons/fa'; // Assuming we need a bell icon in the notification item

function NotificationsDropdown({ onClose }) {
  return (
    <div className="notifications-dropdown">
      <div className="dropdown-header">
        <h3>Notifications</h3>
         <div className="toggle-switch">
            On <input type="checkbox" defaultChecked />
         </div>
        <FaTimes className="close-icon" onClick={onClose} />
      </div>
      <div className="dropdown-content">
        {/* Example Notification Item */}
        <div className="notification-item">
           <div className="notification-icon"><FaBell /></div> {/* Placeholder for icon */}
           <div className="notification-details">
             <div className="notification-title">News Release</div>
             <div className="notification-message">Talkwalker's Sentiment Analysis is Now available for Tik tok Insights data! More Details here.</div>
             <div className="notification-time">21 days ago</div>
           </div>
        </div>
        {/* Add more notification items here */}
      </div>
      <div className="dropdown-footer">
         Mark all as read
      </div>
    </div>
  );
}

export default NotificationsDropdown; 